const Features = () => {
  const features = [
    {
      icon: '🤝',
      title: 'A coordinating agent team',
      description:
        'Run a team of Claude agents that schedule on cron, fire on-demand, and hand work off to each other—with output streamed live as they go.',
      result: 'Not parallel silos. A team that actually passes the baton.',
    },
    {
      icon: '🪪',
      title: 'Voiceprint speaker identity',
      description:
        'Every line is tied to a real person by voiceprint—not an anonymous "Speaker 2"—so the right agent gets the right handoff with the context of who asked.',
      result: 'Who said it is as captured as what was said.',
    },
    {
      icon: '🔒',
      title: 'Local-first, sync when you want it',
      description:
        'Your workspace lives on your machine—no bot joins your calls, and transcription and agents run on your own keys. Want your team on more than one device? Optional encrypted backup & sync moves it with you.',
      result: 'Your keys, your accounts — and your call what syncs.',
    },
    {
      icon: '🔁',
      title: 'The closed loop, in one app',
      description:
        'A meeting becomes a speaker-attributed handoff, the right agent picks it up, acts, and streams the result back—end to end, no glue code.',
      result: 'Stop wiring a notetaker to an automation tool.',
    },
    {
      icon: '🗓️',
      title: 'Schedules & triggers',
      description:
        'Agents run on a schedule or wake on a trigger. A standup at 9am can spawn the day’s tasks before you’ve finished your coffee.',
      result: 'Meetings become triggers for real work.',
    },
    {
      icon: '⚡',
      title: 'Built on Claude',
      description:
        'Agents run on your own Claude subscription, reasoning over transcripts, codebases, and tasks with frontier-model capability—no markup, no reselling.',
      result: 'Frontier intelligence, running under your control.',
    },
  ];

  return (
    <section className="features" id="features">
      <div className="section-container">
        <p className="overline overline--center">WHAT THEY DO</p>
        <h2 className="section-title">A meeting-aware agent workforce you actually own</h2>
        <p className="section-subtitle">
          Notetakers stop at a summary; a lone assistant gets unwieldy fast. Your AI coworkers act
          on what’s said and stay organized, scoped, and in their lane.
        </p>

        <div className="features-grid">
          {features.map((f, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon" aria-hidden="true">
                {f.icon}
              </div>
              <h3>{f.title}</h3>
              <p>{f.description}</p>
              <p className="feature-result">{f.result}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
